import { AuthService } from './../serv/auth.service';
import { Component, OnInit } from '@angular/core';
import { FormControl,FormGroup } from '@angular/forms'
import { from } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {


  form = new FormGroup({
    username:new FormControl(),
    password:new FormControl()
  });

  constructor(private auth: AuthService) {

  }
  loginGo(){
    this.auth.loginwithgoogle();
  };
  loginFc(){
   this.auth.loginwithfacebook();
  };

  ngOnInit() {
  }

}
